import { render, staticRenderFns } from "./SupplierEvaluationContactDetails.vue?vue&type=template&id=95c0a2f4&"
import script from "./SupplierEvaluationContactDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierEvaluationContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports